import { Color } from 'src/games/shared/ColorValue';
import { Helpers } from './Helpers';
/**
 *  Represents a "diagnosis":
 * - Disease name
 * - Color for the color changing test
 * - Healthy cell color for normal cells
 * - Unhealthy cell color for sick cells
 * - Bacteria count and color for count bacteria
 */
export class Diagnosis {
    public diseaseName: string;
    public healthyCellColor: number;
    public sickCellColor: number;
    public bacteriaColor: number;
    public bacteriaCount: number;
    public reactionAsset: string;
    public colorChangerColor: number;

    constructor(diseaseName: string) {
        Diagnosis.DIAGNOSIS_OPTIONS.pop();
    }

    // Get a random fictional alien disease name
    public static getRandomDiseaseName(): string {
        var names = [
            "Diagnosis.Phaser.diseaseNames.0",
            "Diagnosis.Phaser.diseaseNames.1",
            "Diagnosis.Phaser.diseaseNames.2",
            "Diagnosis.Phaser.diseaseNames.3",
            "Diagnosis.Phaser.diseaseNames.4",
            "Diagnosis.Phaser.diseaseNames.5",
        ];
        return names[Phaser.Math.Between(0, names.length - 1)];
    }

    public static getRandomReaction(): string {
        var reactionOptions = ["phaser_flare", "phaser_bubble"];
        return reactionOptions[Phaser.Math.Between(0, reactionOptions.length - 1)];
    }

    // Checks to see if the two diseases are the same
    public static hasSameDiseaseName(disease_1: string, disease_2: string): boolean {
        if (disease_1 !== disease_2) {
            return false;
        }
        return true;
    }

    public static DIAGNOSIS_OPTIONS: Diagnosis[] = [
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.0",
            healthyCellColor:  Color.COLORS.get('pink'),
            sickCellColor: Color.COLORS.get('red'),
            bacteriaColor: Color.COLORS.get('purple'),
            colorChangerColor: Color.COLORS.get('blue'),
            bacteriaCount: 2,
            reactionAsset: "phaser_flare",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.3",
            healthyCellColor:  Color.COLORS.get('pink'),
            sickCellColor: Color.COLORS.get('red'),
            bacteriaColor: Color.COLORS.get('green'),
            colorChangerColor: Color.COLORS.get('blue'),
            bacteriaCount: 3,
            reactionAsset: "phaser_flare",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.1",
            healthyCellColor:  Color.COLORS.get('red'),
            sickCellColor: Color.COLORS.get('pink'),
            bacteriaColor: Color.COLORS.get('yellow'),
            colorChangerColor: Color.COLORS.get('blue'),
            bacteriaCount: 1,
            reactionAsset: "phaser_bubble",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.2",
            healthyCellColor:  Color.COLORS.get('red'),
            sickCellColor: Color.COLORS.get('orange'),
            bacteriaColor: Color.COLORS.get('yellow'),
            colorChangerColor: Color.COLORS.get('green'),
            bacteriaCount: 3,
            reactionAsset: "phaser_bubble",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.4",
            healthyCellColor:  Color.COLORS.get('orange'),
            sickCellColor: Color.COLORS.get('pink'),
            bacteriaColor: Color.COLORS.get('teal'),
            colorChangerColor: Color.COLORS.get('purple'),
            bacteriaCount: 3,
            reactionAsset: "phaser_bubble",
        },
        {
            diseaseName: "Diagnosis.Phaser.diseaseNames.5",
            healthyCellColor:  Color.COLORS.get('orange'),
            sickCellColor: Color.COLORS.get('red'),
            bacteriaColor: Color.COLORS.get('blue'),
            colorChangerColor: Color.COLORS.get('purple'),
            bacteriaCount: 1,
            reactionAsset: "phaser_bubble",
        },
    ];
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/objects/Diagnosis.ts